import React, { useCallback, useMemo } from "react";
import { GlobalBox } from 'components/Box/GlobalBox'
import { useSelector, useDispatch } from "react-redux";
import { useSearch } from "hooks/useSearch";
import AssessmentIcon from '@mui/icons-material/Assessment';
import { TableInputs } from "components/CardTable/TableInputs"
import { dateValidator } from "helpers/dateValidator";
import { newDate } from "helpers/dateTools";
import { LoadingComponent } from "components/Loading/LoadingComponent";
import { setReportSalesCustomerFilters, getReportSalesCustomerAction } from "redux/actions/Reports/reportSalesCustomer/reportSalesCustomerActions";

export const ReportSalesCustomerView = () => {
  const dispatch = useDispatch();
  const { setSnackbar } = useSearch();
  const { isLoadingComp } = useSelector(({ search }) => search);
  const { startDate, endDate, station, customer } = useSelector(({ reportSalesCustomer }) => reportSalesCustomer);


  const maxDate = useMemo(() => newDate(), []);

  const handleSubmit = useCallback((e, isPdf = true) => {
    e.preventDefault()
    if (!station?.length) { setSnackbar("Falta seleccionar planta.", 'warning'); return; }
    if (dateValidator(startDate, endDate, 31, setSnackbar)) return
    if (!customer?.idCustomer) {
      setSnackbar("Falta Cliente")
      return
    }
    dispatch(getReportSalesCustomerAction({ startDate, endDate, stations: station, customer, isPdf }))
  }, [startDate, endDate, station, customer, dispatch, setSnackbar]);


  return (
    <GlobalBox title="Reporte de Venta por Cliente" icon={<AssessmentIcon />} >
      <TableInputs
        reducer="reportSalesCustomer"
        dates
        stations
        multiStations
        customers
        maxDate={maxDate}
        dispatchAction={setReportSalesCustomerFilters}
        submitAction={handleSubmit}
        submitSecond={(e) => handleSubmit(e, false)}
        submitButtonName="PDF"
        loading={isLoadingComp?.loadingReportSalesCustomer}
      />
      {isLoadingComp?.loadingReportSalesCustomer && <LoadingComponent />}
    </GlobalBox >
  );
};
